wbApp.filter('activityCompensationType', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 0:
                return $translate.instant('TXT_VAL_ACTIVITY_COMPENSATION_TYPE_ONE_FOR_ONE');
            case 1:
                return $translate.instant('TXT_VAL_ACTIVITY_COMPENSATION_TYPE_TWO_FOR_ONE');
            case 2:
                return $translate.instant('TXT_VAL_ACTIVITY_COMPENSATION_TYPE_DISABLED');
        }
        
    };
}]);